// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Kof8","toggleWrap":"styles_toggleWrap__2k1Q4","content":"styles_content__1b9jz","selectAreaCode":"styles_selectAreaCode__1misM"};